const formatPhoneNumber = (
  phoneNumber,
  isKoreaPhoneNumber = false,
  maximum = 10
) => {
  let dashAfterFirstNumber = 3;
  let dashAfterSecondNumber = 5;

  if (isKoreaPhoneNumber) {
    dashAfterSecondNumber = 7;
  }

  const numericInput = phoneNumber.replace(/\D/g, "");
  let formattedPhoneNumber = numericInput;
  if (
    numericInput.length >= dashAfterFirstNumber &&
    numericInput.length < dashAfterSecondNumber
  ) {
    formattedPhoneNumber = `${numericInput.slice(
      0,
      dashAfterFirstNumber
    )}-${numericInput.slice(dashAfterFirstNumber)}`;
  } else if (
    numericInput.length >= dashAfterSecondNumber &&
    numericInput.length < maximum + 1
  ) {
    formattedPhoneNumber = `${numericInput.slice(
      0,
      dashAfterFirstNumber
    )}-${numericInput.slice(
      dashAfterFirstNumber,
      dashAfterSecondNumber
    )}-${numericInput.slice(dashAfterSecondNumber)}`;
  }

  return formattedPhoneNumber;
};
export default formatPhoneNumber
